import { render, staticRenderFns } from "./ClaimSent.vue?vue&type=template&id=7b8496c2&"
import script from "./ClaimSent.vue?vue&type=script&lang=js&"
export * from "./ClaimSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports